import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from 'material-ui/SvgIcon';
import { weight } from '../Theme/Typography';
import { grey800, white } from '../Theme/colors';

const iconWrapper = {
  background: white,
  width: 53,
  height: 53,
  borderRadius: '50%',
  display: 'flex',
  margin: 'auto',
  marginBottom: 0,
  boxShadow: '0 0 6px 0 #E6E6E9',
};

const iconStyle = {
  height: 24,
  margin: 'auto',
};

/* eslint-disable max-len */
export const LoadingIcon = () => (
  <div style={iconWrapper}>
    <SvgIcon viewBox="0 0 83 89" className="rotating" style={iconStyle}>
      <path d="m 79.359358,46.208984 c -2.154546,-0.202326 -4.104835,1.264253 -4.361329,3.388672 -2.051948,16.691861 -16.416096,29.236328 -33.447265,29.236328 -10.464935,0 -20.057447,-4.704811 -26.367188,-12.544922 h 15.851563 c 2.154545,0 3.898437,-1.71933 3.898437,-3.84375 0,-2.124417 -1.743892,-3.84375 -3.898437,-3.84375 H 8.0527171 7.9003731 c -0.153896,0 -0.25626,0.04883 -0.410156,0.04883 -0.102597,0 -0.256777,2.01e-4 -0.359375,0.05078 -0.153896,0 -0.256777,0.05098 -0.359375,0.101562 -0.153896,0.05058 -0.25626,0.101764 -0.410156,0.152344 0,0 -0.05222,0.05078 -0.103516,0.05078 -0.102597,0 -0.153778,0.04903 -0.205078,0.09961 -0.102597,0.05058 -0.256778,0.101962 -0.359375,0.203125 -0.102598,0.101163 -0.204043,0.152743 -0.306641,0.253906 -0.102597,0.05058 -0.155215,0.15079 -0.257812,0.251953 -0.102598,0.101163 -0.20456,0.201572 -0.25586,0.302735 -0.0513,0.101162 -0.153778,0.203524 -0.205078,0.304687 l -0.154297,0.302734 c -0.0513,0.101163 -0.102997,0.252353 -0.154296,0.353516 -0.0513,0.101163 -0.05026,0.254306 -0.101563,0.355469 -0.0513,0.101162 -0.103516,0.252353 -0.103516,0.353515 -0.0513,0.151744 -0.05078,0.252553 -0.05078,0.404297 0,0.05058 9.19e-4,0.152545 0.103516,0.203125 v 22.660157 c 0,2.124419 1.743892,3.84375 3.898437,3.84375 2.1545459,0 3.8984379,-1.719331 3.8984379,-3.84375 V 74.28125 c 7.694804,7.738953 18.262595,12.240234 29.599608,12.240234 20.981168,0 38.67777,-15.477625 41.191406,-36.013672 0.256494,-2.124418 -1.281001,-4.045921 -3.435546,-4.298828 z M 74.794904,0 C 72.640358,0 70.896467,1.7193314 70.896467,3.84375 V 14.617188 C 63.201661,6.8782343 52.63387,2.3769531 41.296858,2.3769531 c -20.981169,0 -38.6797239,15.4776259 -41.19335995,36.0136719 -0.256494,2.073837 1.28347205,3.997093 3.38671905,4.25 0.153896,0.05058 0.307041,0.05078 0.460937,0.05078 1.949351,0 3.591164,-1.41795 3.847657,-3.390625 2.051948,-16.69186 16.4160959,-29.234375 33.4472649,-29.234375 10.464935,0 20.057448,4.702852 26.367188,12.542969 H 51.761701 c -2.154545,0 -3.898437,1.719331 -3.898437,3.84375 0,2.124418 1.743892,3.845703 3.898437,3.845703 h 22.982422 0.152344 c 0.153896,0 0.25626,-0.05078 0.410156,-0.05078 0.102598,0 0.256778,-2.01e-4 0.359375,-0.05078 0.153896,0 0.256778,-0.05098 0.359375,-0.101563 0.153896,-0.05058 0.25626,-0.101764 0.410156,-0.152344 0,0 0.05222,-0.04883 0.103516,-0.04883 0.102597,0 0.153779,-0.05098 0.205078,-0.101562 0.102598,-0.05058 0.256778,-0.101961 0.359375,-0.203124 0.102598,-0.101163 0.204043,-0.15079 0.306641,-0.251953 l 0.257812,-0.253907 c 0.102598,-0.101163 0.204561,-0.201571 0.25586,-0.302734 0.0513,-0.101163 0.153779,-0.203526 0.205078,-0.304688 l 0.154297,-0.302734 c 0.0513,-0.101163 0.102998,-0.252353 0.154297,-0.353516 0.0513,-0.101161 0.05026,-0.254306 0.101562,-0.355468 0.0513,-0.101163 0.103516,-0.252353 0.103516,-0.353516 0.0513,-0.151744 0.05078,-0.252553 0.05078,-0.404297 V 26.503906 3.84375 C 78.693342,1.7193314 76.94945,0 74.794904,0 Z" />
    </SvgIcon>
  </div>
);

const overlayStyle = {
  width: '100%',
  position: 'absolute',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  marginBottom: 51,
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  zIndex: 2,
  borderRadius: 6,
};

const h1Style = {
  width: '100%',
  textAlign: 'center',
  alignSelf: 'baseline',
  fontWeight: weight.light,
  fontSize: 20,
  marginTop: 16,
  color: grey800,
};

const LoadingComponent = ({ loading }) => {
  if (!loading) {
    return null;
  }
  return (
    <div style={overlayStyle}>
      <LoadingIcon />
      <h1 style={h1Style}>Loading Content</h1>
    </div>
  );
};

LoadingComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default LoadingComponent;
